import type { Routes } from "shared/react";
import { Router } from "shared/react";
import { CREATOR_ROUTES } from "../create/CreatorRouter.js";
import { USER } from "../util/user.js";
import { EarnedPage } from "./EarnedPage.js";
import { FollowersPage } from "./FollowersPage.js";
import { FollowingPage } from "./FollowingPage.js";
import { LoadProfileContext } from "./ProfileContext.js";
import { ProfilePage } from "./ProfilePage.js";

/** Routes to profile content based on username. */
export function ProfileRouter({ uid, slug = "" }: { uid: string; slug?: string | undefined }): React.ReactElement {
	return (
		<LoadProfileContext uid={uid}>
			<Router path={`/${slug}`} routes={PROFILE_ROUTES} />
		</LoadProfileContext>
	);
}

export function MyProfileRouter({ slug }: { slug: string }): React.ReactElement {
	return <ProfileRouter uid={USER.data.uid} slug={slug} />;
}

const PROFILE_ROUTES: Routes = {
	"/earned": EarnedPage,
	"/earned/{type}s": EarnedPage,
	"/earned/{type}": "/earned/{type}s",
	"/followers": FollowersPage,
	"/following": FollowingPage,
	...CREATOR_ROUTES,
	"/": ProfilePage,
};
